import { useFormContext } from 'react-hook-form';
import { Grid, TextField } from '@mui/material';
import WSTextField from '../../../Components/TextBox/WSTextBox';
import WSDateField from '../../../Components/DateField/WSDateField';

export const Step3Job = () => {
  const { register,formState:{errors},control } = useFormContext();

  return (
  <Grid container spacing={2}>
    <Grid item xs={12} sm={6}>
      {/* <TextField
        label="Department"
        fullWidth
        {...register('department')}
        error={!!errors.department}
        name='department'
        helperText={errors.department?.message as string}
      /> */}
      <WSTextField id="department" label={"Department"} control={control} name='department' />
    </Grid>

    <Grid item xs={12} sm={6}>
      {/* <TextField
        label="Designation"
        fullWidth
        {...register('designation')}
        error={!!errors.designation}
        helperText={errors.designation?.message as string}
      /> */}
      <WSTextField id="designation" label={"Designation"} control={control} name='designation' />
    </Grid>

    <Grid item xs={12} sm={6}>
      {/* <TextField
        label="Employment Type"
        fullWidth
        {...register('employmentType')}
        error={!!errors.employmentType}
        helperText={errors.employmentType?.message as string}
      /> */}
      <WSTextField id="employmentType" label={"Employment Type"} control={control} name='employmentType' />
    </Grid>

    <Grid item xs={12} sm={6}>
      {/* <TextField
        label="Work Mode"
        fullWidth
        {...register('workMode')}
        error={!!errors.workMode}
        helperText={errors.workMode?.message as string}
      /> */}
      <WSTextField id="workMode" label={"Work Mode"} control={control} name='workMode' />
    </Grid>

    <Grid item xs={12} sm={6}>
      {/* <TextField
        label="Date of Joining"
        type="date"
        fullWidth
        {...register('dateOfJoining')}
        InputLabelProps={{ shrink: true }}
        error={!!errors.dateOfJoining}
        helperText={errors.dateOfJoining?.message as string}
      /> */}
      
      <WSDateField id="dateOfJoining" label={"Date of Joining"} control={control} name='dateOfJoining' rules={{required:true}} />
    </Grid>

    <Grid item xs={12} sm={6}>
      {/* <TextField
        label="Date of Confirmation"
        type="date"
        fullWidth
        {...register('confirmationDate')}
        InputLabelProps={{ shrink: true }}
        error={!!errors.confirmationDate}
        helperText={errors.confirmationDate?.message as string}
      /> */}
<WSDateField id="confirmationDate" label={"Date of Confirmation"} control={control} name='confirmationDate' rules={{required:true}}/>
    </Grid>

    <Grid item xs={12} sm={6}>
      {/* <TextField
        label="Manager ID"
        fullWidth
        {...register('manager')}
        error={!!errors.manager}
        helperText={errors.manager?.message as string}
      /> */}
      <WSTextField id="manager" label={"Select Manager"} control={control} name='manager' />
    </Grid>
  </Grid>
);
};